import { render, staticRenderFns } from "./AccountsViewTabGeneral.vue?vue&type=template&id=2b546e8d"
import script from "./AccountsViewTabGeneral.vue?vue&type=script&lang=js"
export * from "./AccountsViewTabGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports